//Feature toggles defined in the Azure App Configuration.
//The values must begin with 'PS_FEATURE_' and be in all caps.
//Employ the useIsFeatureToggleEnabled hook to check if a feature toggle is enabled.
//Ex. PORTFOLIO_WIZARD: 'PS_FEATURE_PORTFOLIO_WIZARD',
export const FEATURE_TOGGLES = {
    PORTFOLIO_WIZARD: 'PS_FEATURE_PORTFOLIO_WIZARD',
};
